import { deprecatedColorThemeConfig } from './deprecatedColors';
export const linkThemeConfig = {
    color: {
        default: deprecatedColorThemeConfig.black.primary,
        hover: deprecatedColorThemeConfig.gray.dark,
    },
    typography: {
        fontSize: '13px',
        fontWeight: 600,
        letterSpacing: '0.6px',
    },
    icon: {
        height: '10px',
        width: '12px',
    },
    underline: {
        lineWidth: '1px',
    },
};
//# sourceMappingURL=link.js.map